<template>
  <template
    v-if="
      hasOneShowingChild(pureMenuData, item) &&
      (!onlyOneChild?.children?.length || onlyOneChild.noShowingChildren) &&
      !item.alwaysShow
    "
  >
  <!-- {{ item }} -->
    <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
      <el-menu-item
        :index="resolvePath(onlyOneChild.path)"
        :class="{ 'submenu-title-noDropdown': !isNest }"
      >
        <slot
          v-if="!isNest"
          :icon="onlyOneChild.meta.icon || (item.meta && item.meta.icon)"
          :className="'svg_icon'"
          key="1"
        ></slot>
        <!-- <svg-icon
        v-if="!isNest"
        :icon-class="
          onlyOneChild.meta.icon || (item.meta && item.meta.icon)
        "
        class="svg_icon"
      /> -->
        <template #title>
          <span
            class="menu-title"
            :class="!isNest ? '' : 'fillspace'"
            :title="hasTitle(onlyOneChild.meta?.title)"
          >
            {{ onlyOneChild.meta?.title }}</span
          >
        </template>
      </el-menu-item>
    </app-link>
  </template>
  <el-sub-menu v-else ref="subMenu" :index="resolvePath(item.path)">
    <template v-if="item.meta" #title>
      <slot
        :icon="item.meta && item.meta.icon"
        :className="'svg_icon'"
        key="2"
      ></slot>
      <span class="menu-title" :title="hasTitle(item.meta?.title)">
        {{ item.meta.title }}</span
      >
    </template>
    <sidebar-item
      v-for="child in pureMenuData"
      :key="child.path"
      :is-nest="true"
      :item="child"
      :base-path="resolvePath(child.path)"
    />
  </el-sub-menu>
</template>
<script setup>
import { ref, nextTick, computed } from "vue";
import path from "path-browserify";
import AppLink from "./Link.vue";
import useMenu from "./useMenu";

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  //第一级菜单需要处理菜单折叠后图标对齐等，其他级不需要
  isNest: {
    type: Boolean,
    default: false,
  },
  basePath: {
    type: String,
    default: "",
  },
});
function resolvePath(routePath) {
  const httpReg = /^http(s?):\/\//;
  if (httpReg.test(routePath) || httpReg.test(props.basePath)) {
    return routePath || props.basePath;
  } else {
    return path.posix.resolve(props.basePath, routePath);
  }
}

const pureMenuData = computed(()=>{
  if (!props.item?.children) props.item.children = [];
  return props.item?.children.filter((item) => !item.hidden)
})

const {  onlyOneChild, hasTitle, hasOneShowingChild } = useMenu(
  props.item?.children
);
</script>

<style lang="scss" scoped>
a:focus,
a:active {
  outline: none;
}

a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
}
</style>
